export default "__VITE_ASSET__upZhSuzN__"